import {defineStore} from 'pinia';
const acceptedCookiesStorage = localStorage.getItem("cookie-consent");

export const useCookiesStore = defineStore('cookies', {
	state: () => ({
		acceptCookies: acceptedCookiesStorage ? acceptedCookiesStorage === 'accept' : null,
	}),
	actions: {
		toggleCookiesChoice(accept) {
			this.acceptCookies = !!accept;
			localStorage.setItem("cookie-consent", this.acceptCookies ? "accept" : "reject");

			if(typeof zaraz !== "undefined") {
				zaraz.consent.setAll(!!true);
				zaraz.consent.sendQueuedEvents();
			}
		},
		loadSavedData(savedData) {
			this.acceptCookies = savedData && savedData.hasOwnProperty("cookies") && savedData.cookies !== null ? savedData.cookies : null;
		}
	}
});